<template>
  <div class="page">
    <van-nav-bar :title="title" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <div class="empty" v-if="showEmpty">
      <div>暂无{{title}}</div>
      <div class="button" @click="scxy">
        上传协议
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-else style="padding-bottom: 100px">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="item-box" v-for="(item, index) in list" :key="index">
          <div class="title-line" v-if="item.isty == '2'">
            <div class="title">公司名称：{{ item.qymc }}</div>
            <div class="date">
              <span
                :class="
                  item.shzt == '审核中'
                    ? 'shzClass'
                    : item.shzt == '未通过'
                    ? 'btgClass'
                    : 'ytgClass'
                "
                >{{ item.shzt }}</span>
            </div>
          </div>
          <div class="date" v-if="item.isty == '2'">岗位名称: {{item.gwmc}}</div>

          <div class="title-line" v-if="item.isty == '1'">
            <div class="title">统一实习</div>
            <div class="date">
              <span
                :class="
                  item.shzt == '审核中'
                    ? 'shzClass'
                    : item.shzt == '未通过'
                    ? 'btgClass'
                    : 'ytgClass'
                "
                >{{ item.shzt }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="button-box" v-if="list.length > 0">
      <van-button @click="scxy">上传协议</van-button>
    </div>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
export default {
  components: {

  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      showEmpty: false,
      title:"第三方协议",
      schoolCode:""
    }
  },
  computed: {
    // 审核状态：0-未通过，1-通过，2-审核中，3-待送审，4-终止流程
    getStatusColor() {
      return status => {
        let color = ['#FFA400', '#41B29C']
        if(status == '待评阅'){
          return color[0]
        }
        return [1]
      }
    }
  },
  methods: {
    async onLoad() {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      const res = await iApi.getDsfxyList({
        type:'1'
      })
      this.list = this.list.concat(res.data)
      this.list.splice(0, 0)
      this.loading = false
      if (res.data.length < this.pageSize) {
        this.finished = true
      } else {
        this.page += 1
      }
      if ((this, this.list.length == 0)) {
        this.showEmpty = true
      }
    },
    async scxy(){
      //判断是否符合上传条件
      const res =  await iApi.getIssctj({ type:'1'})
      if(res.code == '1'){
        this.$router.push({ path: `/internship/dsfxysc` })
      }

    },
    onRefresh() {
      console.log('下拉刷新')
      // 清空列表数据
      this.list = []
      this.page = 1
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    if(this.schoolCode=="14475"){
      this.title="三方协议"
    }
    // this.onLoad()
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
  position: relative;
}
.empty {
  // margin-top: 167px;
  height: calc(100vh - 46px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #666666;
  text-align: center;
  img {
    width: 159px;
    height: 154px;
    margin-bottom: 30px;
  }
  .button {
    width: 232px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px;
    text-align: center;
    line-height: 50px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    margin-top: 50px;
  }
}
.item-box {
  width: 315px;
  min-height: 50px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 12px 15px;
  .title-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      // width: 280px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .status {
      margin-left: 10px;
      min-width: 46px;
      height: 20px;
      border: 1px solid #41b29c;
      border-radius: 10px;
      text-align: center;
      line-height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #41b29c;
    }
  }
  .date {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 5px 0;
    .shzClass {
      color: #7469f8 !important;
    }
    .btgClass {
      color: #f86969 !important;
    }
    .ytgClass {
      color: #12ddd6 !important;
    }
  }
  .tip-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    p {
      color: #0088f8;
    }
  }
}
.button-box {
  width: 100%;
  height: 70px;
  background: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .van-button {
    width: 345px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px !important;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/dsfxy_list.vue